import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {NavControl} from 'modules/navigation/NavBarContainer.js';
import {initNavbarState} from 'actions/navbar.js';
import {fetchMyProfile} from 'actions/user.js';
import {getUserProfileWithDefaults} from 'reducers/user.js';
import Utils from 'utils/Utils.js';
import UserService from 'services/UserService.js';
import Profile from './Profile.js';

class ProfileContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onEditUser = this.onEditUser.bind(this);
        this.onStartSurvey= this.onStartSurvey.bind(this);
        this.onEditSurvey= this.onEditSurvey.bind(this);
    }
    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, mode:'main', title:this.props.t('Profile'), menuEnable:true, backButtonEnable:false, rewardsEnable:true}));
        this.loadData();
    }

    loadData() {
        this.props.dispatch(fetchMyProfile({categories:true, health:true, rank:true}));
    }



    getTotalChallenges() {
        var result = 0;
        this.props.userCategories.list.forEach((id)=>{
            var category = this.props.userCategories.indexed[id]; 
            result+=category.userCategory.activitiesCompleted;
        });
        return result;
    }

    onEditUser() {
        this.props.history.push('/editprofile');
    }

    onStartSurvey(surveyId, micro) {
        sessionStorage.surveyReferrer = this.props.location.pathname;
        if(micro) {
            this.props.history.push('/msurvey/'+surveyId);
        } else {
            this.props.history.push('/survey/'+surveyId);
        }
    }

    onEditSurvey(surveyId) {
        this.props.history.push('/myhealth/'+surveyId);
    }


    render() {
        return (
                <NavControl onDone={this.onEditUser} doneIconOpts={{key:'1', name:'', label:this.props.t('Edit')}}>
                    <Profile userProfile={this.props.userProfile}
                            userHealth={this.props.userHealth}
                            userRank={this.props.userRank}
                            totalChallenges={this.getTotalChallenges()}
                            dataLoaded={this.props.dataLoaded}
                            userCategories={this.props.userCategories}
                            onStartSurvey={this.onStartSurvey}
                            onEditUser={this.onEditUser}
                            onEditSurvey={this.onEditSurvey}>
                    </Profile>
                </NavControl>
            );
  }
}

function mapStateToProps(state, ownProps) {

    var userLoaded = state.user.userProfile!==null;
    var categoriesLoaded = state.userCategories.loaded===true;
    var healthLoaded = state.user.hasOwnProperty('health'); // this prevents the profile from showing when no HRA is enabled -- should be treated a a separate piece and not part of the user state
    var dataLoaded = userLoaded && categoriesLoaded// && healthLoaded;


    return { dataLoaded: dataLoaded, 
             userLoaded: userLoaded, 
             categoriesLoaded: categoriesLoaded, 
             healthLoaded: healthLoaded, 
             userProfile: getUserProfileWithDefaults(state.user), 
             userCategories: state.userCategories, 
             userRank:state.user.rank,
             userHealth: state.user.health };
}
export default withRouter(connect(mapStateToProps)(translate('profile')(ProfileContainer)));



// WEBPACK FOOTER //
// ./src/modules/profile/ProfileContainer.js